import React from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next';
import { FaDownload } from "react-icons/fa";

import './support.css'

const Support = (props) => {

  const { t } = useTranslation();
  
  return (
    <support className="support">
      <div className="support-information">   
        <div className="support-title"><h3 className="thq-heading-3" >{t('support.title')}</h3></div>
        <div className><span className="support-secondary thq-body-large">{t('support.titleSecondary')}</span> <span className="support-button thq-body-small"><FaDownload /><a href={props.sheetSrc}> {t('support.sheet')}</a></span>  </div>
        <div className><span className="support-secondary thq-body-large">{t('support.support2title')}</span> <span className="support-button thq-body-small"><FaDownload /><a href={props.support2SheetSrc}> {t('support.sheet')}</a></span>  </div>
        <div className="support-description"><span className="thq-body-small">{t('support.description')}</span>  </div>
        <div className="support-images"><img
          alt={props.imageAlt}
          src={props.imageSrc}
          className="support-image"
        /></div>
      </div>
    </support>
  )
}

Support.defaultProps = {
  imageAlt: 'image',
  imageSrc:
    '/images/logo_iefp_estagio.png',
    sheetSrc:'/files/Cartaz_Estagios.pdf',
    support2SheetSrc:'/files/Cartaz_Emprego.pdf'
}

Support.propTypes = {
  imageAlt: PropTypes.string,
  imageSrc: PropTypes.string,
  sheetSrc: PropTypes.string,
}

export default Support
